export default "__VITE_ASSET__gEo9mJsG__"